export const enum PredefinedTagName {
  With = ':with:',
  Without = ':without:',
}
